/* eslint-disable react-hooks/exhaustive-deps */
// GlobalContext.tsx
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Define the shape of the context
interface MuteContextType {
  isMuted: boolean;
  setIsMuted: React.Dispatch<React.SetStateAction<boolean>>;
  videoReplayOnPageLoad: any;
  setVideoReplayOnPageLoad: React.Dispatch<React.SetStateAction<any>>;
  language: string;
  setLanguage: React.Dispatch<React.SetStateAction<any>>;
}

// Provide a default value for the context
const GlobalContext = createContext<MuteContextType | undefined>(undefined);

// Provider component
export const GlobalStateProvider = ({ children }: { children: ReactNode }) => {

  const location = useLocation();
  const navigate = useNavigate();

  const [checkOnHardReload, setCheckOnHardReload] = useState<boolean>(false);

  const [history] = useState(() => {
    return JSON.parse(sessionStorage.getItem('history')) || "";
  });

  const [isMuted, setIsMuted] = useState<boolean>(() => {
    return JSON.parse(sessionStorage.getItem('isMuted') || 'false');
  });

  const [videoReplayOnPageLoad, setVideoReplayOnPageLoad] = useState<any>(() => {
    return JSON.parse(sessionStorage.getItem('videoReplay') || '[]');
  });

  const [language, setLanguage] = useState<any>(() => {
    return JSON.parse(sessionStorage.getItem('language')) || "";
  });

  useEffect(() => {
    const checkSessionExpiry = () => {
      const timestamp = sessionStorage.getItem('sessionStart');
      const now = new Date().getTime();

      if (timestamp) {
        const sessionStart = parseInt(timestamp, 10);
        const diff = now - sessionStart;

        if (diff > 10 * 60 * 1000) {
          sessionStorage.clear();
          console.log('Session expired and cleared');
        }
      } else {
        // Set session start time if not already set
        sessionStorage.setItem('sessionStart', now.toString());
      }
    };

    checkSessionExpiry(); // Check immediately on mount

    const interval = setInterval(() => {
      checkSessionExpiry();
    }, 60 * 1000); // Check every 1 minute

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!checkOnHardReload && Boolean(!language/*  || (!!language && location.pathname !== history) */)) {
      setCheckOnHardReload(checkOnHardReload => true);
      navigate("/explore");
    } else {
      sessionStorage.setItem('history', JSON.stringify(location.pathname));
    }
  }, [location.pathname]);

  useEffect(() => {
    sessionStorage.setItem('isMuted', JSON.stringify(isMuted));
  }, [isMuted]);

  useEffect(() => {
    sessionStorage.setItem('videoReplay', JSON.stringify(videoReplayOnPageLoad));
  }, [videoReplayOnPageLoad?.join(",")]);

  useEffect(() => {
    sessionStorage.setItem('language', JSON.stringify(language));
  }, [language]);

  return (
    <GlobalContext.Provider value={{ isMuted, setIsMuted, videoReplayOnPageLoad, setVideoReplayOnPageLoad, language, setLanguage }}>
      {children}
    </GlobalContext.Provider>
  );
};

// Hook to use the context
export const useGlobalState = () => useContext(GlobalContext);